module.exports = __webpack_public_path__ + "app/web/assets/images/onboarding2.png";